/*
 *   File : all-sip.js
 *   Author : https://evoqins.com
 *   Description : Sip detail tab file
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

// custom components
import { CustomDataTable } from '../../../Components/DataTable';
import { Chip, CustomTooltip, Loader } from '../../../Components/Others';
import { APIService } from '../../../Service';
import EmptyScreen from '../../../Components/Others/empty-screen';
import { PrimaryButton, SecondaryButton, TextButton } from '../../../Components/Buttons';
import { Icon } from '../../../Components/Icon';
import { CustomDatePicker, CustomDayPicker, CustomSelectBox, DateRangePicker } from '../../../Components/FormElements';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { SkipHistoryModal } from '../../../Components/Modal';
import { Modal } from 'bootstrap';

const OPTIONS = [
    { id: 1, label: 'Sample 1' },
    { id: 2, label: 'Sample 2' },
    { id: 3, label: 'Sample 3' },
];

const AllSips = () => {
    const scrollRef = useRef(null);
    const PROFILE_DATA = useSelector((store) => store.Reducer.PROFILE_DATA);
    const hasSipDownloadAccess = PROFILE_DATA?.modules?.some(
        (module) => module?.name?.toLowerCase() === "sip download"
    );


    const isRendered = useRef(true);
    const { id } = useParams();
    const [currentPage, setCurrentPage] = useState(1);
    const [sipData, setSipData] = useState({});
    const [loader, setLoader] = useState(true);

    const [filterBtn, setFilterBtn] = useState(false);
    const [rayiStatus, setRayiStatus] = useState(null);
    const [fpStatus, setFpStatus] = useState(null);

    const [upcomingSipDate, setUpcomingSipDate] = useState(null);
    const [upcomingDateToggle, setUpcomingDateToggle] = useState(false);

    const [registeredDate, setRegisteredDate] = useState(null);
    const [registeredDateToggle, setRegisteredDateToggle] = useState(null);

    const [selectedScheme, setSelectedScheme] = useState(null);
    const [isClearFilter, setIsClearFilter] = useState(false);

    const [dataChangeLoader, setDataChangeLoader] = useState(false);

    const [filterData, setFilterData] = useState({});
    const [filterLoader, setFilterLoader] = useState(true);
    const [downloadLoader, setDownloadLoader] = useState(false);

    const [selectedDay, setSelectedDay] = useState(null);

    const [skipHistoryData, setSkipHistoryData] = useState(null);

    const [skipHistoryLoader, setSkipHistoryLoader] = useState({});


    useEffect(() => {
        if (skipHistoryData !== null) {
            const skipHistoryModal = new Modal(document.getElementById('skip-history-modal'));
            skipHistoryModal.show();
        }
    }, [skipHistoryData]);

    useEffect(() => {
        const timer = setTimeout(() => {
            _filterData();
        }, 0);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (isRendered.current === true) {
            _getAllSip();
            setLoader(true);
        }
        isRendered.current = false;
    }, [currentPage, isClearFilter]);

    useEffect(() => {
        if (isClearFilter === true) {
            _getAllSip();
        }
    }, [isClearFilter]);

    // handle table page change 
    const _handleTablePageChange = (page_num) => {
        setCurrentPage(page_num);
        _getAllSip(page_num);
        if (scrollRef.current) {
            scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
        setDataChangeLoader(true);
    };

    // handle filter
    const _handleFilter = () => {
        setFilterBtn(prev => !prev);
    };

    // handle select date 
    const _handleSelectUpcomingSipDate = (date) => {
        setUpcomingSipDate(date);
        setUpcomingDateToggle(false);
    };

    // handle select registered date 
    const _handleSelectRegisteredDate = (date) => {
        setRegisteredDate(date);
        setRegisteredDateToggle(false);
    };

    const _handleClear = () => {

        setUpcomingSipDate(null);
        setSelectedDay(null)
        setRegisteredDate(null);

        setFpStatus(filterData.fp_status[0])
        setRayiStatus(filterData.rayi_status[0])
        setSelectedScheme(filterData.investment_type[0]);


        setCurrentPage(1);
        setIsClearFilter(true);
        setDataChangeLoader(true);
    };

    const _handleFilterSelected = () => {
        _getAllSip(1);
        setCurrentPage(1);
        setDataChangeLoader(true);
    };

    // handle view skip history
    const _handleViewSkips = (row) => {
        setSkipHistoryLoader(prev => ({ ...prev, [row.sip_id]: true }));
        _skipHistory(row.sip_id);
    };


    // const SIPExpandableRow = ({ data }) => {
    //     if (!data.plan_datas || data.plan_datas.length === 0) {
    //         return <div className="p-3 e-text-black e-primary-font e-font-14 e-font-weight-400 line-height-16px">No schemes available.</div>;
    //     }

    //     return (
    //         <div className="py-3 pe-4 padding- ms-4" style={{ paddingLeft: "56px" }}>
    //             <p className="mb-1 e-text-black e-primary-font e-font-14 e-font-weight-400 line-height-16px">Schemes:</p>

    //             <div className="d-flex justify-content- py-1 ">
    //                 <p style={{ width: "170px" }} className='mb-0 e-text-dark-silver e-primary-font e-font-14 e-font-weight-600 line-height-16px'>
    //                     Mutual fund ID
    //                 </p>
    //                 <p style={{ width: "380px" }} className='mb-0 e-text-dark-silver e-primary-font e-font-14 e-font-weight-600 line-height-16px'>
    //                     FP Purchase ID
    //                 </p>
    //                 <p style={{ width: "320px" }} className='mb-0 e-text-dark-silver e-primary-font e-font-14 e-font-weight-600 line-height-18px'>
    //                     Fund name
    //                 </p>
    //                 <p style={{ width: "120px" }} className=' ms-5 mb-0 e-text-dark-silver e-primary-font e-font-14 e-font-weight-600 line-height-18px'>
    //                     Amount
    //                 </p>
    //             </div>
    //             <div className='d-flex flex-column gap-1'>
    //                 {data.plan_datas.map((item, index) => (
    //                     <div key={index} className="d-flex justify-content- py-1 ">
    //                         <p style={{ width: "170px" }} className='mb-0 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>{item.mf_id}</p>
    //                         <p style={{ width: "380px" }} className='mb-0 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>{item.fp_plan_id}</p>
    //                         <p style={{ width: "320px" }} className='mb-0 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-18px'>{item.fund_name}</p>
    //                         <p style={{ width: "120px" }} className='ms-5 mb-0 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-18px'>{item?.amount}</p>
    //                     </div>
    //                 ))}
    //             </div>
    //         </div>
    //     );
    // };


    // Pending request data table column 

    const ExpandableRows = ({ data }) => {

        const bgClass = data._index % 2 === 0 ? 'e-bg-magnolia-dark' : 'e-bg-magnolia-extra-dark';

        if (!data.data || data.data.length === 0) {
            return <div className={`${bgClass} p-3 e-text-black e-primary-font e-font-14 e-font-weight-400 line-height-16px`}>No data available.</div>;
        }

        return (
            <div className={`py-3 padding-30px-lr d-flex flex-column gap-3 ${bgClass}`} >
                {data.data.map((child_data, index) => (
                    <div key={index} className='d-flex align-items-center'>
                        <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px text-truncate' style={{ width: "200px" }} data-column-id="sip_registered_date" title={child_data.setup_date || undefined}>
                            {child_data.setup_date || "-"}
                        </p>

                        <div style={{ width: "120px" }} data-column-id="sip_order_type">
                            <Chip label={"Child"}
                                textAlign="justify-content-start"
                                className={"bg-transparent e-text-green-crayola e-border-1px-green-crayola "} />
                        </div>
                        <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px text-truncate' style={{ width: "130px" }} data-column-id="sip_product">
                            {child_data.product_type || "-"}
                        </p>
                        <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px text-truncate' style={{ width: "300px" }} data-column-id="sip_product_name" title={child_data.product_name || undefined}>
                            {child_data.product_name || "-"}
                        </p>
                        <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-22px pe-2 text-truncate' style={{ width: "300px" }} data-column-id="sip_scheme" title={child_data.scheme || undefined}>
                            {child_data.scheme || "-"}
                        </p>
                        <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px' style={{ width: "130px" }} data-column-id="sip_amount">
                            ₹{child_data.sip_amount}
                        </p>
                        <div style={{ width: "140px" }} data-column-id="sip_rayi_status">
                            {child_data.rayi_sip_status !== null ?
                                <Chip label={child_data.rayi_sip_status}
                                    textAlign="justify-content-start"
                                    className={`${child_data.rayi_sip_status.toLowerCase() === "active" ? "e-text-green-crayola e-border-1px-green-crayola" : "e-text-maximum-red e-border-1px-maximum-red"} bg-transparent `} />
                                : "-"}
                        </div>
                        <div style={{ width: "140px" }} data-column-id="sip_fp_status">
                            {child_data.fp_sip_status !== null ?
                                <Chip label={child_data.fp_sip_status}
                                    textAlign="justify-content-start"
                                    className={`${child_data.fp_sip_status.toLowerCase() === "success" || child_data.fp_sip_status.toLowerCase() == "active" || child_data.fp_sip_status.toLowerCase() === "confirmed" ? "e-text-green-crayola e-border-1px-green-crayola" :
                                        child_data.fp_sip_status.toLowerCase() === "failed" || child_data.fp_sip_status.toLowerCase() === "cancelled" ? "e-text-maximum-red e-border-1px-maximum-red" : child_data.fp_sip_status.toLowerCase() === "pending" || child_data.fp_sip_status.toLowerCase() === "under_review" ? "e-text-marigold e-border-1px-marigold" : "e-text-bleu-de-france e-border-1px-solid-bleu-de-france"} bg-transparent `} />
                                :
                                "-"
                            }
                        </div>
                        <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px' style={{ width: "180px" }} data-column-id="sip_day">
                            {child_data.sip_day || "-"}
                        </p>
                        <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px' style={{ width: "130px" }} data-column-id="sip_start_date">
                            {child_data.start_date || "-"}
                        </p>
                        <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px' style={{ width: "150px" }} data-column-id="sip_upcoming_date">
                            {child_data.upcoming_sip_date || "-"}
                        </p>
                        <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px' style={{ width: "90px" }} data-column-id="sip_executed">
                            {child_data.executed_sip || "-"}
                        </p>

                        <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px' style={{ width: "140px" }} data-column-id="sip_skip_count">
                            {child_data.skip_count || "-"}
                        </p>

                        <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px' style={{ width: "120px" }} data-column-id="sip_tenure">
                            {child_data.sip_tenure || "-"}
                        </p>

                        <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px' style={{ width: "120px" }} data-column-id="sip_cancelled_date">
                            {child_data.cancelled_date !== null ? '"' : "-"}
                        </p>
                        <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px text-truncate' style={{ width: "300px" }} data-column-id="sip_cancelled_reason">
                            {child_data.cancelled_reason !== null ? '"' : "-"}
                        </p>
                        <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px' style={{ width: "130px" }} data-column-id="sip_cancelled_by">
                            {child_data.cancelled_by !== null ? '"' : "-"}
                        </p>

                        <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px text-truncate' style={{ width: "260px" }} data-column-id="sip_bank_name" title={child_data.bank_name || undefined}>
                            {child_data.bank_name || "-"}
                        </p>
                        <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px text-truncate' style={{ width: "130px" }} data-column-id="sip_mandate_id" title={child_data.mandate_id || undefined}>
                            {child_data.mandate_id || "-"}
                        </p>
                        <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px' style={{ width: "130px" }} data-column-id="sip_mandate_type">
                            {child_data.mandate_type || "-"}
                        </p>

                        <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px' style={{ width: "140px" }} data-column-id="sip_step_up_due_date">
                            {"-"}
                        </p>
                        <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px' style={{ width: "120px" }} data-column-id="sip_step_up_value">
                            {"-"}
                        </p>
                        <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px' style={{ width: "150px" }} data-column-id="sip_step_up_date">
                            {"-"}
                        </p>

                        <div style={{ width: "120px" }} data-column-id="sip_step_up_status">
                            {child_data.status_text ?
                                <Chip label={child_data.status_text}
                                    className={child_data.status_text === "Active" ? "e-bg-green-crayola" :
                                        child_data.status_text === "Inactive" ? "e-bg-taupe-gray " :
                                            child_data.status_text === "Pending" ? "e-bg-marigold" : "e-bg-bleu-de-france"
                                    } />
                                :
                                "-"
                            }
                        </div>
                        <p className='mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px text-truncate' style={{ width: "320px" }} data-column-id="sip_fp_purchase_id" title={child_data.fp_sip_id || undefined}>
                            {child_data.fp_sip_id || "-"}
                        </p>
                    </div>
                ))}
            </div>
        );
    };

    const SIP_DATA_COLUMN = [
        {
            name: <span className="e-table-th-wrap">Registered<br />date</span>,
            selector: row => row.setup_date ? row.setup_date : "-",
            cell: (row) => <span className='text-truncate d-block' title={row.setup_date || undefined}>{row.setup_date || "-"}</span>,
            width: "200px",
            sortable: true,
            format: row => row.setup_date,
            id: "sip_registered_date",
        },

        {
            name: 'Order Type',
            cell: row => <Chip label={"Parent"}
                className={"e-bg-green-crayola"} />,
            width: "120px",
            id: "sip_order_type",
        },
        {
            name: 'Product',
            selector: row => row.product_type !== null ? row.product_type : "-",
            width: "130px",
            id: "sip_product",
        },
        {
            name: 'Product Name',
            cell: row => <div>
                <p className={`${row.product_type === "Basket" || row.product_type === "Goals" ? "cursor-pointer" : ""} mb-0 truncate-third-line line-height-20px`}
                >
                    {row.product_name || "-"}
                </p>
            </div>,
            width: "300px",
            id: "sip_product_name",
        },
        {
            name: 'Scheme',
            cell: row => <span className='text-truncate d-block' title={row.scheme || undefined}>{row.scheme ? row.scheme : "-"}</span>,
            width: "300px",
            id: "sip_scheme",
        },
        {
            name: 'SIP amount',
            selector: row => row.sip_amount,
            cell: row => <span>₹{row.sip_amount}</span>,
            sortable: true,
            width: "130px",
            id: "sip_amount",
        },
        {
            name: 'Rayi SIP Status',
            cell: row => <>
                {row.rayi_sip_status !== null ?
                    <Chip label={row.rayi_sip_status}
                        className={row.rayi_sip_status.toLowerCase() === "active" ? "e-bg-green-crayola" : "e-bg-maximum-red"} />
                    : "-"}
            </>,
            width: "140px",
            id: "sip_rayi_status",
        },

        {
            name: 'FP SIP Status',
            cell: row => <>
                {row.fp_sip_status !== null ?
                    <Chip label={row.fp_sip_status}
                        className={row.fp_sip_status.toLowerCase() === "success" || row.fp_sip_status.toLowerCase() == "active" || row.fp_sip_status.toLowerCase() === "confirmed" ? "e-bg-green-crayola" : row.fp_sip_status.toLowerCase() === "failed" || row.fp_sip_status.toLowerCase() === "cancelled" ? "e-bg-maximum-red" : row.fp_sip_status.toLowerCase() === "pending" || row.fp_sip_status.toLowerCase() === "under_review" ? "e-bg-marigold" : "e-bg-bleu-de-france"} />
                    :
                    "-"
                }
            </>,
            width: "140px",
            id: "sip_fp_status",
        },
        {
            name: <span className="e-table-th-wrap">SIP day</span>,
            selector: row => row.sip_day ? row.sip_day : "-",
            cell: row => <span className='text-truncate d-block' title={row.sip_day || undefined}>{row.sip_day || "-"}</span>,
            width: "180px",
            id: "sip_day",
        },
        {
            name: 'Start date',
            selector: row => row.start_date ? row.start_date : "-",
            cell: (row) => <>{row.start_date || "-"}</>,
            width: "130px",
            sortable: true,
            format: row => row.start_date,
            id: "sip_start_date",
        },
        {
            name: 'Upcoming SIP date',
            selector: row => row.upcoming_sip_date ? row.upcoming_sip_date : "-",
            width: "150px",
            id: "sip_upcoming_date",
        },
        {
            name: <span className="e-table-th-wrap">Executed<br />SIPs</span>,
            selector: row => row.executed_sip !== null ? row.executed_sip : "-",
            width: "90px",
            id: "sip_executed",
        },
        {
            name: 'Skip Count',
            selector: row => row.skip_count ?? "-",
            cell: (row) =>
                <div className='d-flex align-items-center gap-3'>
                    <span>{row.skip_count ?? "-"}</span>
                    {row.skip_count > 0 &&
                        <div className={`${skipHistoryLoader[row.sip_id] ? "pe-none opacity-75" : ""} d-flex align-items-center`}>
                            <TextButton name="View Skips"
                                fontSize="e-font-12"
                                fontWeight="e-font-weight-400"
                                onClick={() => _handleViewSkips(row)} />

                            {skipHistoryLoader[row.sip_id] && <Loader width={20} height={20} className="margin--4px-left margin--4px-bottom" />}
                        </div>
                    }
                </div>,
            width: "140px",
            id: "sip_skip_count",
        },
        {
            name: 'SIP tenure',
            selector: row => row.sip_tenure !== null ? row.sip_tenure : "-",
            width: "120px",
            id: "sip_tenure",
        },

        {
            name: 'Cancelled date',
            selector: row => row.cancelled_date !== null ? row.cancelled_date : "-",
            width: "120px",
            id: "sip_cancelled_date",
        },
        {
            name: 'Cancelled reason',
            // cell: row => <div className='truncate-first-line'>
            //     {row.cancelled_reason !== null ? row.cancelled_reason : "Investor does not have amount or is unable to continue due to some bank level debit issues"}
            // </div>,
            cell: (row, index) => {
                const text =
                    row.cancelled_reason !== null
                        ? row.cancelled_reason
                        : "-";

                const tooltipId = `cancelled-reason-${index}`;

                return (
                    <div className="truncate-first-line"   >
                        <span
                            data-tooltip-id={tooltipId}
                            data-tooltip-content={text}
                        >
                            {text}
                        </span>

                        {row.cancelled_reason !== null &&
                            <CustomTooltip id={tooltipId}
                                icon={false}
                                content={text}
                                offset={-16}
                                width="320px"
                            />
                        }
                    </div>
                );
            },
            width: "300px",
            id: "sip_cancelled_reason",
        },
        {
            name: 'Canceled by',
            selector: row => row.cancelled_by !== null ? row.cancelled_by : "-",
            width: "130px",
            id: "sip_cancelled_by",
        },
        {
            name: 'Bank name',
            cell: row => <span className='text-truncate d-block' title={row.bank_name || undefined}>{row.bank_name !== null ? row.bank_name : "-"}</span>,
            width: "260px",
            id: "sip_bank_name",
        },
        {
            name: 'Mandate ID',
            selector: row => row.mandate_id || "-",
            cell: row => <span className='text-truncate d-block' title={row.mandate_id || undefined}>{row.mandate_id || "-"}</span>,
            width: "130px",
            id: "sip_mandate_id",
        },
        {
            name: 'Mandate Type',
            selector: row => row.mandate_type || "-",
            width: "130px",
            id: "sip_mandate_type",
        },

        {
            name: 'Step-up Start Date',
            selector: row => row.step_up_due_date !== null ? row.step_up_due_date : "-",
            width: "140px",
            id: "sip_step_up_due_date",
        },
        {
            name: 'Step-up % / ₹',
            selector: row => row.step_up_percentage !== null ? row.step_up_percentage : row.step_up_amount !== null && row.step_up_amount !== undefined ? `₹${row.step_up_amount}` : "-",
            width: "120px",
            id: "sip_step_up_value",
        },
        {
            name: 'Step-up Date',
            selector: row => row.step_up_start_date !== null ? row.step_up_start_date : "-",
            width: "150px",
            id: "sip_step_up_date",
        },
        {
            name: 'Step-up Status',
            cell: (row) =>
                <>
                    {row.status_text ?
                        <Chip label={row.status_text}
                            className={row.status_text === "Active" ? "e-bg-green-crayola" :
                                row.status_text === "Inactive" ? "e-bg-taupe-gray " :
                                    row.status_text === "Pending" ? "e-bg-marigold" : "e-bg-bleu-de-france"
                            } /> : "-"
                    }
                </>,
            width: "120px",
            id: "sip_step_up_status",
        },
        {
            name: 'FP Purchase ID',
            selector: row => row.fp_sip_id || "-",
            cell: row => <span className='text-truncate d-block' title={row.fp_sip_id || undefined}>{row.fp_sip_id || "-"}</span>,
            width: "320px",
            id: "sip_fp_purchase_id",
        },
    ];

    // API - Skip history
    const _skipHistory = (sip_id) => {
        if (!sip_id) return;

        let is_post = true;
        let url = 'sip/skip-history';
        let request = {
            "sip_id": sip_id
        }

        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setSkipHistoryData(response.data);
            } else {
                setSkipHistoryData(null);
            }
            setSkipHistoryLoader(prev => ({ ...prev, [sip_id]: false }));
        })
    };

    // API - get sip data
    const _getAllSip = (page_num = currentPage) => {

        let updated_rayi_status = [];
        let updated_fp_status = [];

        if (rayiStatus != null && rayiStatus?.value !== null) {
            updated_rayi_status = rayiStatus.filter(item => item?.value != null).map((value) => {
                return value.value
            })
        }

        if (fpStatus !== null && fpStatus?.value !== null) {
            updated_fp_status = fpStatus.filter(item => item?.value != null).map((value) => {
                return value.value
            });
        }

        const upcoming_start_date = upcomingSipDate === null ? null : format(new Date(upcomingSipDate[0]), 'dd-MM-yyyy');
        const upcoming_end_date = upcomingSipDate === null ? null : format(new Date(upcomingSipDate[1]), 'dd-MM-yyyy');

        const registered_start_date = registeredDate === null ? null : format(new Date(registeredDate[0]), 'dd-MM-yyyy');
        const registered_end_date = registeredDate === null ? null : format(new Date(registeredDate[1]), 'dd-MM-yyyy');


        let is_post = true;
        let url = 'user/sip';
        let request = {
            "customer_id": id,
            "page_num": page_num,
            "page_size": 10,

            "rayi_status": updated_rayi_status,
            "fp_status": updated_fp_status,
            "investment_type": selectedScheme?.value,

            // "upcoming_start_date": upcoming_start_date,
            // "upcoming_end_date": upcoming_end_date,
            "registered_start_date": registered_start_date,
            "registered_end_date": registered_end_date,
            "sip_day": selectedDay
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {

                const updated_data = response.data.sips.map((item, index) => ({
                    ...item,
                    _index: index
                }));

                setSipData({
                    ...response.data,
                    sips: updated_data
                });
            }
            else {
                setSipData({ sips: [] });
            }
            setLoader(false);
            setIsClearFilter(false);
            setDataChangeLoader(false);
        });
    };


    // API - Get login otp
    const _filterData = () => {
        let is_post = false;
        let url = 'sip/sip-filter-data';
        APIService(is_post, url).then((response) => {
            if (response.status_code === 200) {
                setFilterData(response.data);

                setFpStatus(response.data.fp_status[0])
                setRayiStatus(response.data.rayi_status[0])
                setSelectedScheme(response.data.investment_type[0]);
            } else {
                setFilterData([]);
            }
            setFilterLoader(false);
        });
    };

    // API - Sip list download
    const _sipDownload = () => {
        setDownloadLoader(true);

        let updated_rayi_status = [];
        let updated_fp_status = [];

        if (rayiStatus != null && rayiStatus?.value !== null) {
            updated_rayi_status = rayiStatus.filter(item => item?.value != null).map((value) => {
                return value.value
            })
        }

        if (fpStatus !== null && fpStatus?.value !== null) {
            updated_fp_status = fpStatus.filter(item => item?.value != null).map((value) => {
                return value.value
            });
        }

        const upcoming_start_date = upcomingSipDate === null ? null : format(new Date(upcomingSipDate[0]), 'dd-MM-yyyy');
        const upcoming_end_date = upcomingSipDate === null ? null : format(new Date(upcomingSipDate[1]), 'dd-MM-yyyy');

        const registered_start_date = registeredDate === null ? null : format(new Date(registeredDate[0]), 'dd-MM-yyyy');
        const registered_end_date = registeredDate === null ? null : format(new Date(registeredDate[1]), 'dd-MM-yyyy');

        let is_post = true;
        let url = 'sip/sip-download';
        let request = {
            "customer_id": id,
            "rayi_status": updated_rayi_status,
            "fp_status": updated_fp_status,
            "investment_type": selectedScheme?.value,

            "upcoming_start_date": upcoming_start_date,
            "upcoming_end_date": upcoming_end_date,
            "registered_start_date": registered_start_date,
            "registered_end_date": registered_end_date,
            "sip_day": selectedDay
        }

        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                const url = response.data.url;
                const link = document.createElement('a');
                link.href = url;
                link.download = ''; // Optional: specify a file name
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                toast.dismiss();
                toast.success(response.message, { type: "error" })
            }
            setDownloadLoader(false);
        })
    };

    return (
        <Fragment>
            {loader ?
                <div className='d-flex align-items-center justify-content-center  min-vh-100'>
                    <img src={require("../../../Assets/Image/loader.gif")}
                        draggable={false}
                        width={80}
                        height={80}
                        alt='loader'
                        className='text-center' />
                </div>
                :
                <>
                    <div ref={scrollRef} className='padding-32px-all '>
                        {/* SIP summary */}
                        <h6 className='mb-0 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                            SIP summary
                        </h6>


                        {sipData && sipData?.sips?.length !== 0 &&
                            <div className='row pt-3'>
                                <div className='col-3'>
                                    <div className={`e-bg-lavender-dark border-radius-4 p-3 d-flex flex-column h-100 gap-2 justify-content-between `}>
                                        <p className='mb-0 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px '>
                                            No of active SIPs
                                        </p>
                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-20px'>
                                            {sipData?.total_active_sip_count}
                                        </p>
                                    </div>
                                </div>
                                {/* <div className='col-3'>
                                    <div className={`e-bg-lavender-dark border-radius-4 p-3 d-flex flex-column h-100 gap-2 justify-content-between `}>
                                        <p className='mb-0 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px '>
                                            Total SIP amount
                                        </p>
                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-20px'>
                                            {sipData.total_sip_amount}
                                        </p>
                                    </div>
                                </div> */}
                            </div>
                        }

                    </div>

                    <div ref={scrollRef} >
                        <div className='d-flex align-items-center gap-4 justify-content-end padding-32px-lr pb-2'>
                            {hasSipDownloadAccess &&
                                <SecondaryButton name="Download List"
                                    disabled={dataChangeLoader || sipData?.sips?.length === 0 ? true : false}
                                    loader={downloadLoader}
                                    className={downloadLoader ? "w-129px h-42px" : ""}
                                    onClick={_sipDownload}
                                />
                            }

                            <div className={` padding-10px-all border-radius-8 e-cursor-pointer e-border-1px-light-purple cursor-pointer 
                          ${filterBtn ? ' e-bg-blue-violet ' : ''}`}
                                onClick={_handleFilter}>
                                <Icon icon='filter'
                                    size='1.25rem'
                                    className='d-flex'
                                    color={filterBtn && "#FFFFFF"} />
                            </div>
                        </div>

                        {/* <div className={`e-filter-content  ${filterBtn === true ? 'expanded ' : 'collapsed'}`}> */}
                        <div className={`e-filter-content ${filterBtn && loader === false ? 'expanded ' : 'collapsed'}  `}>

                            <div className='e-bg-main-white pt-3 pb-4 padding-32px-lr'>
                                <div className='d-flex justify-content-end'>
                                    <TextButton name="Clear all"
                                        onClick={_handleClear}
                                    />
                                </div>
                                <div className='d-flex gap-4 padding-32px-bottom'>
                                    <CustomSelectBox
                                        title={"Rayi Status"}
                                        placeholder='Select'
                                        controlWidth='9.5rem'
                                        options={filterData.rayi_status}
                                        loader={filterLoader}
                                        isMulti={true}
                                        type={3}
                                        isSearchable={false}
                                        value={rayiStatus}
                                        onChange={(value) => setRayiStatus(value)} />

                                    <CustomSelectBox
                                        title={"FP Status"}
                                        placeholder='Select'
                                        controlWidth='9.5rem'
                                        options={filterData.fp_status}
                                        loader={filterLoader}
                                        isSearchable={false}
                                        isMulti={true}
                                        type={3}
                                        value={fpStatus}
                                        onChange={(value) => setFpStatus(value)} />

                                    {/* <DateRangePicker label="Upcoming SIP Date"
                                        placeholder="Select"
                                        calendarWrapperClass="end-0"
                                        value={upcomingSipDate}
                                        minDate={new Date}
                                        handleClear={() => setUpcomingSipDate(null)}
                                        handleChange={(date) => setUpcomingSipDate(date)} /> */}

                                    <CustomDayPicker label="Upcoming SIP Day"
                                        placeholder="Select"
                                        selected={selectedDay}
                                        handleClear={() => setSelectedDay(null)}
                                        handleSelect={(day) => setSelectedDay(day)} />

                                    <DateRangePicker label="Registered date"
                                        placeholder="Select"
                                        calendarWrapperClass="end-0"
                                        value={registeredDate}
                                        maxDate={new Date}
                                        handleClear={() => setRegisteredDate(null)}
                                        handleChange={(date) => setRegisteredDate(date)} />

                                    <CustomSelectBox
                                        title={"Product"}
                                        placeholder='Select'
                                        controlWidth='9rem'
                                        loader={filterLoader}
                                        options={filterData.investment_type}
                                        isSearchable={false}
                                        value={selectedScheme}
                                        onChange={(value) => setSelectedScheme(value)} />
                                </div>

                                <PrimaryButton name='Filter now'
                                    paddingBlock='padding-12px-tb padding-40px-lr'
                                    onClick={_handleFilterSelected} />
                            </div>
                        </div>

                        {sipData?.sips?.length !== 0 &&
                            <div className='pt-2 padding-32px-lr d-flex gap-1 align-items-center justify-content-end'>
                                <div>
                                    <img src={require("../../../Assets/Image/scroll-animation.gif")}
                                        draggable={false}
                                        className='e-rotate-270'
                                        width={24}
                                        height={24}
                                        alt='scroll' />
                                </div>
                                <p className='mb-0 e-text-bleu-de-france e-alt-font e-font-12 e-font-weight-500 line-height-14px'>
                                    Scroll horizontally for view more information
                                </p>
                            </div>
                        }
                    </div>

                    {/* SIP list table */}

                    {dataChangeLoader ?
                        <div className='d-flex align-items-center justify-content-center  min-vh-100'>
                            <img src={require("../../../Assets/Image/loader.gif")}
                                draggable={false}
                                width={80}
                                height={80}
                                alt='loader'
                                className='text-center' />
                        </div>
                        :
                        <>
                            {sipData?.sips?.length !== 0 ?
                                <div className={`e-data-table-wrapper-striped pt-3 pb-4 mt-2`}>
                                    <CustomDataTable columns={SIP_DATA_COLUMN}
                                        data={sipData.sips}
                                        // expandOnRows={true}
                                        expandableRowsComponent={ExpandableRows}
                                        expandableRowDisabled={row => (row.product_type === "Basket" || row.product_type === "Goals")}
                                        defaultExpandedRows={row => (row.product_type === "Basket" || row.product_type === "Goals")}
                                        striped
                                        pagination={true}
                                        paginationPerPage={10}
                                        paginationDefaultPage={sipData.current_page}
                                        paginationTotalRows={sipData.total_count}
                                        lastPage={sipData.total_page}
                                        onChangePage={_handleTablePageChange} />
                                </div>
                                :
                                <EmptyScreen
                                    image={require('../../../Assets/Image/NotFound/no-data.png')}
                                    title='No results found'
                                    description={`We couldn' t find anything that matches your search. Try checking your spelling, using different keywords, or exploring popular funds.`}
                                />
                            }
                        </>
                    }

                </>
            }

            {skipHistoryData !== null &&
                <SkipHistoryModal data={skipHistoryData}
                    handleClose={() => {
                        setTimeout(() => {
                            setSkipHistoryData(null);
                        }, 200);
                    }} />
            }
        </Fragment >
    )
}

export default AllSips;